// 当前做题进度持久化（localStorage）
// 以题目列表的首尾题目 id 作为 key，保存 { answers, currentIndex }
// 每位用户的进度使用独立的 storage key，互不干扰

function getStorageKey() {
  try {
    const raw = localStorage.getItem('bjt_auth_session');
    const session = raw ? JSON.parse(raw) : null;
    const userId = session?.id ?? 'local';
    return `bjt_progress_${userId}`;
  } catch {
    return 'bjt_progress_local';
  }
}

function loadAll() {
  try {
    const raw = localStorage.getItem(getStorageKey());
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function saveAll(data) {
  try {
    localStorage.setItem(getStorageKey(), JSON.stringify(data));
  } catch {
    // 存储空间不足时静默失败
  }
}

/**
 * 根据题目列表生成唯一 key
 * @param {Array} questions
 * @returns {string}
 */
export function makeProgressKey(questions) {
  if (!questions || questions.length === 0) return "empty";
  return `${questions[0].id}_${questions[questions.length - 1].id}_${questions.length}`;
}

/**
 * 读取某套题目的做题进度
 * @param {string} key
 * @returns {{ answers: Object, currentIndex: number }}
 */
export function loadProgress(key) {
  const all = loadAll();
  return all[key] || { answers: {}, currentIndex: 0 };
}

/**
 * 保存某套题目的做题进度
 * @param {string} key
 * @param {Object} answers  { [questionId]: selectedOptionIndex }
 * @param {number} currentIndex
 */
export function saveProgress(key, answers, currentIndex) {
  const all = loadAll();
  all[key] = { answers, currentIndex };
  saveAll(all);
}

/**
 * 清除某套题目的做题进度
 * @param {string} key
 */
export function clearProgress(key) {
  const all = loadAll();
  delete all[key];
  saveAll(all);
}
